<template>
<div class="info">
	<div class="title">保障计划及人员</div>
	<Form :label-width="120" ref="form" class="mt15">
		<template  v-if="from!='policy'">
			<FormItem label="保障期限：" class="w600">{{info.insurancePeriod==12?'1年':info.insurancePeriod+'月'}}</FormItem>
			<FormItem label="保障起期：" class="w600">{{info.effectiveDateStart}}</FormItem>
			<FormItem label="保障止期：" class="w600">{{info.effectiveDateEnd}}</FormItem>
		</template>
		<template v-if="info.productCode!='SUNLIGHT_EMPLOYER_LIABILITY'&&info.extraInfo&&info.extraInfo.isSubjoinAllDay">
			<FormItem label="附加险：" class="w600">
				<p v-if="info.extraInfo.isSubjoinAllDay">附加24小时</p>
			</FormItem>
		</template>
		<template v-else>
			<div v-if="info.extraInfo">
				<FormItem label="保障方案：" class="w600">{{info.extraInfo.schemeName}}</FormItem>
				<FormItem label="附加险：" class="w600">
					<p v-if="info.extraInfo.isSubjoinProportionAdj">十级伤残10%</p>
					<p v-else>十级伤残5%</p>
					<p v-if="info.extraInfo.isCanteenAndDormitoryLiability">员工食堂、宿舍责任</p>
				</FormItem>
			</div>
		</template>
	</Form>
	<div class="recognize-table mt10 pb20" v-if="info.productCode=='SUNLIGHT_EMPLOYER_LIABILITY'">
		<el-table class="mt10" ref="table" :data="info.subjectMatterGroupStats" border style="width:800px">
			<el-table-column type="index" label="序号" width="80" align="center" key="index"></el-table-column>
			<el-table-column prop="quoteRiskCategoryName" label="风险类别" min-width="100" align="center" key="quoteRiskCategoryName"></el-table-column>
			<el-table-column prop="quantity" label="人数" min-width="100" align="center" key="quantity"></el-table-column>
			<el-table-column prop="unitPremium" label="保费单价（元/人）" min-width="100" align="center" key="unitPremium"></el-table-column>
			<el-table-column prop="totalPremium" label="保费小计（元）" min-width="100" align="center" key="totalPremium"></el-table-column>
		</el-table>
	</div>
	<div class="recognize-table mt10 pb20" v-else>
		<el-table class="mt10" ref="table" :data="tableData" border style="width: 100%">
			<el-table-column prop="jobTypeName" label="工种" show-overflow-tooltip width="180"></el-table-column>
			<el-table-column prop="schemeName" label="保障方案" show-overflow-tooltip width="180"></el-table-column>
			<el-table-column prop="riskCategory" label="风险类别" show-overflow-tooltip width="180">
				<template slot-scope="{row}">
					{{riskCategoryShow(row.riskCategory)}}
				</template>
			</el-table-column>
			<el-table-column prop="companyNameFrom" label="派遣单位" show-overflow-tooltip width="180"></el-table-column>
			<el-table-column prop="companyNameTo" label="实际用工单位" show-overflow-tooltip width="180"></el-table-column>
			<el-table-column prop="desc" label="工作描述备注" show-overflow-tooltip width="180"></el-table-column>
			<el-table-column prop="province" label="用工省" show-overflow-tooltip width="180"></el-table-column>
			<el-table-column prop="city" label="用工市" show-overflow-tooltip width="180"></el-table-column>
			<el-table-column prop="district" label="用工区" show-overflow-tooltip width="180"></el-table-column>
			<el-table-column prop="insuredPersonName" label="姓名" width="120"></el-table-column>
			<el-table-column prop="idCard" label="身份证号" width="190">
				<template slot-scope="{ row }">
					{{from=='order'?hideIdCard(row.idCard):row.idCard}}
				</template>
			</el-table-column>
			<el-table-column prop="gender" label="性别" width="70"></el-table-column>
			<el-table-column prop="age" label="年龄"  width="70"></el-table-column>
			<el-table-column prop="effectiveDateStart" label="保障起期" width="180"></el-table-column>
			<el-table-column prop="effectiveDateEnd" label="保障止期" width="180"></el-table-column>
			<el-table-column prop="premium" label="保费(元)" width="110">
				<template slot-scope="{ row }">
					{{row.premium||'-'}}
				</template>
			</el-table-column>
		</el-table>
		<Row class="mt10" v-if="tableData.length>0">
			<Col :span="24" class="right">
				<el-pagination
					:current-page="pageinfo.page"
					:page-size="pageinfo.size"
					:total="pageinfo.total"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					layout="prev, pager, next"
				>
				</el-pagination>
			</Col>
		</Row>
	</div>
	<Form :label-width="120" ref="form" v-if="from!='confirm'">
		<FormItem 
			label="投保单：" 
			class="w600">
			<div style="display:flex;flex-wrap:wrap;">
				<ImageShow 
					v-for="(img,i) in info.insurancePolicyUrl"
					:url="img"
					:del="!info.isCorrect"
					@del-img="delImg(i)"
					:key="i" />
				<UploadFileImg v-if="$route.query.orderType==1&&!info.correctUrl"
					@on-success="val=>uploadSuccess(val)" 
					:accept="['image']"
					style="width:100px">
					<div class="upload-img-main">
						<Icon type="ios-camera" size="20"></Icon>
						<p>点击上传</p>
					</div>
				</UploadFileImg>
			</div>
		</FormItem>
        <FormItem 
            label="批改单（盖章）：" :label-width="140" v-if="info.correctUrl||(info.correctUrls&&info.correctUrls.length>0)">
            <div style="display:flex;flex-wrap:wrap;" v-if="from=='policy'">
                <div v-for="(item,i) in info.correctUrls" :key="i" class="correctUrlItem">
                    <img :src="item.correctUrl" height="140"/>
                    <p>
						<a :href="item.correctUrl" target="_blank">查看大图</a>
						{{item.createTime}}
					</p>
                </div>
            </div>
            <div style="display:flex;margin-top: 14px;" v-if="from=='order'">
                <!-- <ImageShow :url="info.correctUrl"/> -->
                <div style="display:flex;flex-wrap:wrap;">
                    <div v-for="(item,i) in info.correctUrls" :key="i" class="correctUrlItem">
                        <img :src="item.correctUrl" height="140"/>
                        <p>
                            <a :href="item.correctUrl" target="_blank">查看大图</a>
                            <a @click="del(i)" v-if="info.correctUrls.length!=1" style="color:red">删除</a>
                            <!-- {{item.createTime}} -->
                        </p>
                    </div>
                </div>
				<UploadFileImg v-if="$route.query.orderType==1&&info.isCorrect"
					@on-success="val=>uploadSuccess(val,'correctUrls')" 
					:accept="['image']"
					style="width:100px">
					<div class="upload-img-main">
						<Icon type="ios-camera" size="20"></Icon>
						<p>上传</p>
					</div>
				</UploadFileImg>
            </div>
        </FormItem>
	</Form>
</div>
</template>
<script>
import ImageShow from './common/Image'
import UploadFileImg from './common/UploadFileImg'
export default {
	components:{ImageShow,UploadFileImg},
	props:{
		info:Object,
		from:{
			type:String,
			default:'confirm'// confirm/order/policy
		},
	},
	data () {
		return {
			list:[],
			imgList:[],
			tableData:[],
			pageinfo: {
				page: 1,
				size: 20,
				total: 0,
			}
		}
	},
	computed:{
	   days(){
			if(this.info.effectiveDateStart&&this.info.effectiveDateEnd){
				return this.getDays(this.formatDate(this.info.effectiveDateStart),this.formatDate(this.info.effectiveDateEnd));
			}else {
				return ""
			}
		},
	},
	watch:{
		info:function (newVal) {
			if(newVal.subjectMatter&&newVal.subjectMatter.length>0){
				this.list = newVal.subjectMatter;
                this.pageinfo.total = this.list.length;
                this.tableData =  this.currentChangePage(this.pageinfo.size,this.pageinfo.page)
			}
		}
	},
	methods: {
		riskCategoryShow(name){
			let str = ''
			switch(name){
				case 'RISK_1':
					str = "一类"
				break;
				case 'RISK_2':
					str = "二类"
				break;
				case 'RISK_3':
					str = "三类"
				break;
				case 'RISK_4':
					str = "四类"
				break;
				case 'RISK_5':
					str = "五类"
				break;
				case 'RISK_6':
					str = "六类"
				break;
				default:
					str = ""
				break;
			}
			return str
		},
		// 上传回调方法
		uploadSuccess(val,key){
			if (key) this.info[key].push({correctUrl: val.url})
			else this.info.insurancePolicyUrl.push(val.url)
		},
		delImg (index) {
			this.info.insurancePolicyUrl.splice(index,1)
		},
        del (index) {
			this.info.correctUrls.splice(index,1)
		},
		hideIdCard (str,frontLen=4,endLen=3) { 
			var len = str.length-frontLen-endLen;
			var star = '';
			for (var i=0;i<len;i++) {
				star+='*';
			}
			return str.substring(0,frontLen)+star+str.substring(str.length-endLen);
		},
		toEdit () {
			this.checkOrderRefuseStatus({
				policyId:this.info.id,
				bizCode:'KAS_GZ_GYS'
			}).then(()=>{
				this.$axios.post('/employerLiability/checkUnPaidOrder.json',{
					id:this.info.id
				}).then(res=>{
					if(res){
						this.$router.push(`/company-group-employergs/edit/${this.info.id}`)
					}
				});
			})
		},
		/** 切换每页显示条数 */
		handleSizeChange(val) {
			this.pageinfo.page = 1;
			this.pageinfo.size = val;
			this.tableData = this.currentChangePage(val, this.pageinfo.page);
			this.pageinfo.total = this.list.length;
		},
		/** 切换分页 */
		handleCurrentChange(val) {
			this.pageinfo.page = val;
			this.tableData = this.currentChangePage(this.pageinfo.size, val);
			this.pageinfo.total = this.list.length;
		},
		// 分页方法
		currentChangePage(size, current) {
			const tablePush = [];
			let array = this.jsonCopy(this.list);
			array.forEach((item, index) => {
				if (size * (current - 1) <= index && index <= size * current - 1) {
				tablePush.push(item);
				}
			});
			return tablePush;
		}
	},
}
</script>
<style scoped lang="less">
	.info{
		margin-top:10px;
	}
	.title-a{
		font-size: 14px;
		margin-left: 15px;
	}
	.pb20{
		padding-bottom: 20px;
	}
    .correctUrlItem{
        margin-right: 20px;
        text-align: center;
		a{
			font-size: 12px;
			// display: block;
            margin-right: 5px;
		}
    }
	.subtitle {
		color: #FF9900;
		font-size: 16px;
		margin-left: 20px;
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/companyGroupEmployerDadi/RecognizeInfo.vue